<div class="container" *ngIf="data">
    <h1 *ngIf="data && data.headline" [innerHTML]="data.headline"></h1>
    <div class="large">
        <p *ngIf="data && data.firstParagraph" [innerHTML]="data.firstParagraph"></p>
        <div class="cards" *ngIf="data && data.cards && data.cards.length > 0">
            <da-teaser-box *ngFor="let card of data.cards" [data]="card"></da-teaser-box>
        </div>
        <ng-container *ngIf="availableCourses$ | async as availableCourses">
            <div class="card" *ngIf="availableCourses.length === 1">
                <da-course-teaser
                    [showBookingBtn]="true"
                    [showDetailsBtn]="true"
                    [mediaLeft]="true"
                    [course]="availableCourses[0]"
                ></da-course-teaser>
            </div>
        </ng-container>
        <p *ngIf="data && data.secondParagraph" [innerHTML]="data.secondParagraph"></p>
    </div>
</div>
